import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="payment-cancel-page">
      <div className="text-center max-w-md">
        <XCircle className="w-12 h-12 mx-auto text-muted-foreground" />
        <h1 className="font-heading text-2xl font-bold mt-4">Paiement annulé</h1>
        <p className="text-sm text-muted-foreground mt-1">Aucun montant n'a été débité.</p>
        <div className="mt-5 flex items-center justify-center gap-3">
          <Link to="/abonnement" className="text-primary font-medium hover:underline" data-testid="cancel-retry-link">Revoir les offres</Link>
          <span className="text-muted-foreground">·</span>
          <Link to="/" className="text-muted-foreground hover:text-foreground">Retour</Link>
        </div>
      </div>
    </div>
  );
}
